import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { Notification } from '../../models/notification.interface';

interface NotificationWithTimer extends Notification {
  isRemoving?: boolean;
}

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  notifications: NotificationWithTimer[] = [];
  private subscription?: Subscription;
  private autoRemoveDelay = 4000; // 4 seconds

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications$.subscribe(
      (notification: Notification) => {
        this.addNotification(notification);
      },
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /**
   * Add a new notification and schedule its auto-removal
   */
  private addNotification(notification: Notification): void {
    const notificationWithTimer: NotificationWithTimer = {
      ...notification,
      isRemoving: false,
    };

    this.notifications.push(notificationWithTimer);

    // Auto-remove after delay
    setTimeout(() => {
      this.removeNotification(notification.id);
    }, this.autoRemoveDelay);
  }

  /**
   * Remove a notification with fade-out animation
   */
  removeNotification(id: string): void {
    const notification = this.notifications.find((n) => n.id === id);
    if (notification) {
      // Trigger fade-out animation
      notification.isRemoving = true;

      // Remove from array after animation completes
      setTimeout(() => {
        this.notifications = this.notifications.filter((n) => n.id !== id);
      }, 300); // Match this with CSS animation duration
    }
  }
}
